import exemplarDataClassicJson from '../data/exemplar.json';
import exemplarDataAnnotJson from '../data/exemplar-annot.json';
import scenarioDataJson from '../data/scenario.json';
import skillDescriptionDataJson from '../data/skill-description.json';
import skillDataJson from '../data/skill.json';
import tagDataJson from '../data/tag.json';
import annotationDataClassicJson from '../data/annotation.json';
import annotationDataAnnotJson from '../data/annotation-annot.json';
import peerResultsJson from '../data/peer-results.json';
import avoidReasonsJson from '../data/avoid-reason.json';
import evalExemplarsJson from '../data/eval-exemplar.json';
import fixedOptionsJson from '../data/fixed-options.json';
import fixedExemplarsJson from '../data/fixed-exemplars.json';
import {
  Exemplar,
  PeerResult,
  Skill,
  SkillDescription,
  Scenario,
  Tag,
  Annotation,
  AvoidReason,
  EvalExemplar,
  FixedOptionExemplar,
  FixedOption
} from './its-db-types';

export const exemplarDataClassic = exemplarDataClassicJson as Exemplar[];
export const exemplarDataAnnot = exemplarDataAnnotJson as Exemplar[];
export const scenarioData = scenarioDataJson as Scenario[];
export const skillDescriptionData = skillDescriptionDataJson as SkillDescription[];
export const skillData = skillDataJson as Skill[];
export const tagData = tagDataJson as Tag[];
export const annotationDataClassic = annotationDataClassicJson as Annotation[];
export const annotationDataAnnot = annotationDataAnnotJson as Annotation[];
export const peerResultsData = peerResultsJson as PeerResult[];
export const avoidReasonsData = avoidReasonsJson as AvoidReason[];
export const evalExemplarsData = evalExemplarsJson as EvalExemplar[];
export const fixedOptionsData = fixedOptionsJson as FixedOption[];
export const fixedOptionExemplarsData = fixedExemplarsJson as FixedOptionExemplar[];
